import React from "react";
import { translate } from "../../../../../../common/providers";
import styles from "./PackageHeaders.module.css";

export default function PackageHeaders() {
	return (
		<div className={styles.main}>
			<div className={styles.sortColumn}>#</div>
			<div className={styles.nameColumn}>{translate("dsi.package-management.table.header.internal-name")}</div>
			<div className={styles.displayedColumn}>
				{translate("dsi.package-management.table.header.displayed-to-all")}
			</div>
			<div>{translate("dsi.package-management.table.header.seg-flags")}</div>
			<div>{translate("dsi.package-management.table.header.companies")}</div>
			<div>{translate("dsi.package-management.table.header.projects")}</div>
		</div>
	);
}
